import { render } from "./NavUserGroupsSidebar.vue?vue&type=template&id=566dcfc5"
import script from "./NavUserGroupsSidebar.vue?vue&type=script&lang=js"
export * from "./NavUserGroupsSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__